// extracted by mini-css-extract-plugin
export var typingIndicator = "_s8-0";